import React, { Fragment } from 'react';
import { string, func, oneOf } from 'prop-types';
import { Icons, Card, withGTM } from 'components';
import { FormattedMessage } from 'react-intl';
import { useFeatureFlags } from 'hooks';
import classnames from 'classnames';
import './TipsheetCard.scss';

const TIPSHEET_CARD_MODE = {
    GRID: 'grid',
    LIST: 'list',
};

function TipsheetCard({
    backgroundPicture,
    link,
    title,
    headlineTitle,
    className,
    pushToGTM,
    mode,
}) {
    const style = {
        backgroundImage: `url('${backgroundPicture}')`,
    };

    const [{ isProductCardRedesign }] = useFeatureFlags({
        isProductCardRedesign: 'browsing.new.product.card',
    });

    const basicTipsheetClasses = classnames(
        'product-card-tipsheet',
        'product-card-root',
        'product-list__product',
        'products__product',
    );

    const listRootClassName = classnames(
        basicTipsheetClasses,
        'product-card-tipsheet-list',
        {
            'product-card-tipsheet--hidden':
                !isProductCardRedesign || mode !== TIPSHEET_CARD_MODE.LIST,
        },
        className,
    );

    const gridRootClassName = classnames(
        basicTipsheetClasses,
        'product-card-tipsheet-grid',
        {
            'product-card-tipsheet--hidden':
                isProductCardRedesign && mode !== TIPSHEET_CARD_MODE.GRID,
        },
        className,
    );

    function handleClick() {
        pushToGTM({
            event: 'click_on_tipsheet',
            event_trigger: 'tipsheet_card',
        });
    }

    return (
        <Fragment>
            <Card className={listRootClassName} onClick={handleClick}>
                <a
                    data-qa="tipsheetLinkCta"
                    data-event-trigger="tipsheet_card"
                    className="product-card-tipsheet__wrapper"
                    href={link}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <div
                        style={style}
                        className="product-card-tipsheet-list__image"
                    />
                    <div className="product-card-tipsheet__container">
                        <p className="product-card-tipsheet__title">
                            <span>
                                {headlineTitle} {title}
                            </span>
                        </p>

                        <div className="product-card-tipsheet__button-wrapper">
                            <span className="product-card-tipsheet__button">
                                <FormattedMessage
                                    id="listing.tipsheetCard.title"
                                    defaultMessage="Advice sheet"
                                    description="Advice sheet card title in listing"
                                />
                                <Icons.OpenInNewTab className="icon icon__external_link" />
                            </span>
                        </div>
                    </div>
                </a>
            </Card>
            <Card
                className={gridRootClassName}
                style={style}
                onClick={handleClick}
            >
                <a
                    data-qa="tipsheetLinkCta"
                    data-event-trigger="tipsheet_card"
                    className="product-card-tipsheet__wrapper"
                    href={link}
                >
                    <p className="product-card-tipsheet__title">
                        <span>
                            {headlineTitle} {title}
                        </span>
                    </p>
                    <div className="product-card-tipsheet__button-wrapper">
                        <span className="product-card-tipsheet__button">
                            <FormattedMessage
                                id="listing.tipsheetCard.title"
                                defaultMessage="Advice sheet"
                                description="Advice sheet card title in listing"
                            />
                            <Icons.ChevronRight className="icon" />
                        </span>
                    </div>
                </a>
            </Card>
        </Fragment>
    );
}

TipsheetCard.propTypes = {
    backgroundPicture: string.isRequired,
    link: string.isRequired,
    title: string.isRequired,
    headlineTitle: string,
    className: string,
    pushToGTM: func.isRequired,
    mode: oneOf([TIPSHEET_CARD_MODE.GRID, TIPSHEET_CARD_MODE.LIST]),
};

TipsheetCard.defaultProps = {
    className: '',
    headlineTitle: '',
    mode: TIPSHEET_CARD_MODE.GRID,
};

export default withGTM(TipsheetCard);
